import originAxios from 'axios'
import { Message, MessageBox } from 'element-ui'
import Vue from 'vue'
import VueI18n from '../i18n/i18n'
let $I18n = VueI18n

let ready
const axiosPromise = new Promise(r => (ready = r))
// console.log(axiosPromise)
export { ready }
let URL;
// axios.defaults.headers.common.fuzhen = '1.0.0'
// let pathlang = localStorage.getItem('lang') || 'en'
// axios.defaults.baseURL = 'http://api.tozo.com/api/v1/'
function goLigin(store, router){
	router.replace({
		path: '/login',
		query: {
			redirect: router.currentRoute.fullPath
		}
	})
}

Vue.prototype.$IsConfirmExecute = false
console.log(Vue.prototype.$IsConfirmExecute)
function LoginTips(store, router){
	if(Vue.prototype.$IsConfirmExecute) { return }
	Vue.prototype.$IsConfirmExecute = true
	MessageBox.confirm(
	   $I18n.t('ConfirmPrompt.experience_more'),
	   $I18n.t('ConfirmPrompt.Login_Tips'),
	   {
	      confirmButtonText: $I18n.t('buttonArr.Confirm'),
	      cancelButtonText: $I18n.t('buttonArr.Cancel'),
	      type: 'warning',
	   }
	).then((res) => {
		try {
		   // 用户点击了确认按钮
		   goLigin(store, router)
			console.log("用户点击了确认按钮")
		} catch (error) {
		   console.error('Error in then block:', error);
		}
		Vue.prototype.$IsConfirmExecute = false
	}).catch((err) => {
	   // 用户点击了取消按钮
		Vue.prototype.$IsConfirmExecute = false
		console.log("用户点击了取消按钮")
	});
}



const originAxiosPromise = axiosPromise.then(({ store, router}) => {
	// 全局的originAxios.defaults.baseURL
	originAxios.defaults.baseURL = process.env.VUE_APP_API_URL
	console.log(originAxios.defaults.baseURL)
	// originAxios.defaults.baseURL = process.env.VUE_APP_API_URL_business
	originAxios.defaults.timeout = 100000

	originAxios.interceptors.request.use(
		config => {
			// let token = "d9cb48d379ce3b7da4644418ebcc2758"
			const login_token = store.state.userinfo.login_token
			if (login_token) {
			  config.headers['token'] = login_token
			}
			config.headers['lang'] = 'en'
			return config
		},
		error => {
			return Promise.reject(error)
		}
	)

	originAxios.interceptors.response.use(function(response) {
		const { data } = response
		if (data.code === 0) return data
		if(data.code === 4001){
			store.commit('changeUserinfo', {})
			LoginTips(store, router)
		}
		return Promise.reject(data)
	
	}, (error) => {
		if (error.response) {
      switch (error.response.status) {
			// 401: 未登录
			// 未登录则跳转登录页面，并携带当前页面的路径
			// 在登录成功后返回当前页面，这一步需要在登录页操作。
			case 4001:
				store.commit('changeUserinfo', {})
				LoginTips(store, router)
         break
			
			case 404:
         Message({
            message: $I18n.t('tipsArr.network_request'),
            type: 'error'
         })
         break
         // 其他错误，直接抛出错误提示
      }
      return Promise.reject(error.response)
   }
   return Promise.reject(error)
  })
  return originAxios
})

// function getQueryString(name) {
//   var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
//   var r = window.location.search.substr(1).match(reg)
//   if (r != null) {
//     return unescape(r[2])
//   }
//   return null
// }
// let locaLang = localStorage.getItem('lang') || 'en'
// const lang = getQueryString('lang') || locaLang

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
	originAxios.defaults.baseURL = process.env.VUE_APP_API_URL
	return new Promise((resolve, reject) => {
		originAxiosPromise.then(axios => {
			axios.get(url, { params }).then(res => resolve(res), err => reject(err))
		})
	})
}

// export function get (url, params) {
//   return axios.get(url, { params })
// }

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
var arr = [
  'login','login/google','login/facebook','forget','reset_pwd','logout','emailCode','register','forgetemailCode','checkregister',
  'center/login', 'center/login/google', 'center/login/facebook', 'center/checkregister', 'center/register', 'center/forgetemailCode', 'center/forget', 'center/emailCode',
  'center/getshopifylink',
]

export function post(url, params, config) {
	// arr.some(function(v){ if(v == url){
	// 	originAxios.defaults.baseURL = process.env.VUE_APP_API_URL_user
	// }})
	return new Promise((resolve, reject) => {
		originAxiosPromise.then(axios => {
			axios.post(url, params, config).then(res => resolve(res), err => reject(err))
		})
	})
}

// PUT
export function put(url, params) {
	originAxios.defaults.baseURL = process.env.VUE_APP_API_URL
	return new Promise((resolve, reject) => {
		originAxiosPromise.then(axios => {
			axios.put(url, params).then(res => resolve(res), err => reject(err))
		})
	})
}

// DELETE
export function Delete(url, params) {
	originAxios.defaults.baseURL = process.env.VUE_APP_API_URL
	return new Promise((resolve, reject) => {
		originAxiosPromise.then(axios => {
			axios.delete(url, { params }).then(res => resolve(res), err => reject(err))
		})
	})
}
